// extracted by mini-css-extract-plugin
module.exports = {"ownedCollectionDot":"addToCollectionButton_ownedCollectionDot__u_cQM","greenDot":"addToCollectionButton_greenDot__QLn57"};